// Frontend-managed game reward coupons (fixed set)
const gameCoupons = [
  { text: "🏆 Game Win: 10% off", text_ar: "🏆 فوز باللعبة: خصم 10%", code: "GAME10", type: "percentage", discount: 10, minAmount: 5 },
  { text: "🏆 Game Win: 15% off", text_ar: "🏆 فوز باللعبة: خصم 15%", code: "GAME15", type: "percentage", discount: 15, minAmount: 8 },
  { text: "🏆 Game Win: 20% off", text_ar: "🏆 فوز باللعبة: خصم 20%", code: "GAME2O", type: "percentage", discount: 20, minAmount: 10 },
  { text: "🏆 Game Win: 2 OMR off", text_ar: "🏆 فوز باللعبة: خصم 2 ريال", code: "GAME2OFF", type: "fixed", discount: 2, minAmount: 8 },
  { text: "🏆 Game Win: 3 OMR off", text_ar: "🏆 فوز باللعبة: خصم 3 ريال", code: "GAME3OFF", type: "fixed", discount: 3, minAmount: 12 },
  { text: "🏆 Game Win: 5 OMR off", text_ar: "🏆 فوز باللعبة: خصم 5 ريال", code: "GAME5OFF", type: "fixed", discount: 5, minAmount: 20 },
];

export default gameCoupons;
